import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "app/quick-signals";
const BROADCAST_PATH = "app/broadcast";

@Injectable({
  providedIn: "root",
})
export class BroadcastHandlerService {
  constructor(private apiService: ApiService) {}

  broadcastsGet(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      startDate?: string;
      endDate?: string;
      facility_id?: number[];
      listView?: boolean;
      page?: number;
      perPage?: number;
    },
  ) {
    return this.apiService.get(`${PATH}/${masterAccountID}/${accountAppID}`, {
      params: queryParams,
    });
  }

  broadcastGet(
    masterAccountID: number,
    accountAppID: number,
    broadcastID: number,
  ) {
    return this.apiService.get(
      `${PATH}/${masterAccountID}/${accountAppID}/${broadcastID}`,
    );
  }

  broadcastPost(
    masterAccountID: number,
    accountAppID: number,
    broadcastDTO: any,
  ) {
    return this.apiService.post(
      `${BROADCAST_PATH}/${masterAccountID}/search/${accountAppID}`,
      broadcastDTO,
    );
  }

  broadcastDelete(
    masterAccountID: number,
    accountAppID: number,
    broadcastID: number,
  ) {
    return this.apiService.delete(
      `${PATH}/${masterAccountID}/${accountAppID}/${broadcastID}`,
    );
  }

  broadcastPut(
    masterAccountID: number,
    accountAppID: number,
    broadcastDTO: any,
  ) {
    return this.apiService.put(
      `${PATH}/${masterAccountID}/${accountAppID}/${broadcastDTO.id}`,
      broadcastDTO,
    );
  }

  redemptionsGet(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
    },
  ) {
    return this.apiService.get(
      `${BROADCAST_PATH}/${masterAccountID}/${accountAppID}/redemptions`,
      { params: queryParams },
    );
  }
}
